import { FILE_TYPES } from "../data";
import convertBase64ToBlob from "./convertBase64ToBlob";

const convertbase64ToBlobToFile = (base64: string, fileName: string, type = FILE_TYPES.PDF) => {
    const blobFile = convertBase64ToBlob(base64, type);
    return new File([blobFile], fileName, { type });
};

export default convertbase64ToBlobToFile;